import type { BoardItem } from '@/utils/moodboard'
import type { MoodboardStore } from '@/stores/moodboard'
import type { Alpine as AlpineType } from 'alpinejs'

export function saveButton(Alpine: AlpineType) {
  Alpine.data('saveButton', (item: BoardItem) => ({
    moodboard: Alpine.store('moodboard') as MoodboardStore,

    async addItem() {
      try {
        this.moodboard.addItemToDefaultBoard(item)
        this.$dispatch('openAddToMenu', { item })
      } catch (error) {
        this.$dispatch('createToast', {
          type: 'error',
          heading: 'Oops',
          message: 'Unable to add item. Moodboards are limited to 50 items',
        })
      }
    },

    async removeItem() {
      try {
        this.$dispatch('openAddToMenu', { item })
      } catch (error) {
        console.error('Error removing item from moodboard:', error)
        this.$dispatch('createToast', {
          type: 'error',
          heading: 'Error',
          message: 'Could not remove item from moodboard.',
        })
      }
    },

    toggleSaved() {
      if (this.isSaved) {
        this.removeItem()
      } else {
        this.addItem()
      }
    },

    get isSaved() {
      return this.moodboard.isSaved(item.id, item.context)
    },
  }))
}
